/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';
import CallBackVue from './components/callback/CallBack';

export default class CallBack {

    constructor(mainContainer) {
       this.mainContainer = mainContainer;
    }

    /**
     * @returns {boolean}
     * @private
     */
    _isExist() {
        return $(this.mainContainer).length !== 0;
    }

    _callBackVue() {

        let callBackApp = new Vue({
            el: this.mainContainer,
            components: {
                CallBackVue
            },
            template: '<CallBackVue></CallBackVue>',
        });
    }

    init() {

        if (!this._isExist()) return;

        this._callBackVue();
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/vue/CallBack.js